import { render, staticRenderFns } from "./BayesTheory.vue?vue&type=template&id=a41bc666&scoped=true&"
import script from "./BayesTheory.vue?vue&type=script&lang=js&"
export * from "./BayesTheory.vue?vue&type=script&lang=js&"
import style0 from "./BayesTheory.vue?vue&type=style&index=0&id=a41bc666&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a41bc666",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\web\\V-LAB\\project\\bayes-vue2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a41bc666')) {
      api.createRecord('a41bc666', component.options)
    } else {
      api.reload('a41bc666', component.options)
    }
    module.hot.accept("./BayesTheory.vue?vue&type=template&id=a41bc666&scoped=true&", function () {
      api.rerender('a41bc666', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BayesTheory.vue"
export default component.exports